module.exports = __webpack_public_path__ + "static/media/impact-aba.57d9ab0e.png";